import * as angular from 'angular';
import {IController} from 'angular';


export class SmsStatusSelectListComponent implements IController {

  selectedId: any;
  ngPlaceholder: any;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.messages')
  .component('smsStatusSelectList', {
    bindings: {
      selectedId: '<',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./sms-status-select-list.html').default,
    controller: SmsStatusSelectListComponent
  });
